<template>
	<div class="funcListContainer">
		<div class="funcListTitle">二维码常用功能组件一览，可自由搭配设计</div>
		<div v-if="funcData.length>0" class="funcList" v-for="(item,index) in funcData">
			<div class="funcListL">
				<span class="funclistNum">{{index+1}}</span>
				<div class="funclistInfo">
					<img class="funclistInfoImg" :src="item.img_url" alt="">
					<div class="funclistDesc">
						<div class="funclistDesc1">
							<h2>{{item.title}}</h2><span class="funcIsnew" v-if="item.newest==1">最新</span>
						</div>
						<p class="funclistDesc2">{{item.description}}</p>
					</div>
				</div>
			</div>
			<div class="funcListR">
				<span class="funcListR1">{{item.name}}</span>
				<div class="funcListR2">
					<!-- <span class="mbm-iconfont mbm-VIP" v-if="item.is_free==2"></span> -->
					<span style="margin-left: 6px;">{{item.is_free==1?'免费':'VIP'}}</span>
				</div>
				<a-button @click="caseView(item,index)" type="primary" class="funcListGo">体验</a-button>
			</div>
		</div>
		
		<!-- 二维码详细设置 -->
		<a-modal :destroyOnClose="true" :footer="null" :centered="true" width="1000px" :visible="qrcodeSetConfig.showDetailSet" :title="title" @cancel="qrcodeSetCancel" @ok="qrcodeSetOk">
			<div class="preview_wrap">
				<settings @setcurrent="setcurrent" :idKey="qrcodeSetConfig.id_key" :styleConfig="qrcodeSetConfig.styleConfig" :showConfig="qrcodeSetConfig.showConfig"></settings>
			</div>
		</a-modal>
	</div>
	
	
</template>

<script>
	import settings from './settings.vue';
	export default{
		name:'lists',
		components: {
			settings
		},
		data(){
			return {
				funcData:[],
				title:'',
				qrcodeSetConfig:{
					id_key:'',
					showDetailSet:false,/*显示二维码设置*/
					styleConfig: {//样式设置，可不填
						iframe: {
							// height:"auto",
							// width:'200px',//默认320px
							// height:'400px',//默认900px
							//...
						},
						settings: {
							// width:'300px',//默认500px
							//...
						}
					},
					showConfig: {//显示内容设置，可不填
						iframe: true, //显示左侧预览iframe
						settings: false, //显示右侧设置整体
						settings_qrcode: true, //设置头部二维码图片+标题
						settings_list: true, //二维码设置部分收起/展开
						settings_list_expire: true, //设置有效期
						settings_list_auth: true, //设置查看权限
						settings_list_open: true, //设置打开方式（链接类型此项不论设置什么值最终都为false）
						settings_list_bot: true, //底部设置
						settings_list_video: true, //视频下载设置
						settings_list_file_download:true,//文件下载设置
						settings_list_file_nonstop:true,//文件直达
						settings_extra: {
							show:true,
							title:"扫码预览",
							currentindex:0,/*当前点击的数组索引*/
							lists:[],//所有数据
						},
					},
				},
				
			}
		},
		created() {
			this.getFunctionaltyInfo();
		},
		mounted() {
			
		},
		beforeDestroy() {
		},
		methods:{
			setcurrent(index){
				this.title=index+1+'.'+this.funcData[index].name
				this.addFunctionaltyHeat(this.funcData[index].id);
			},
			caseView(item,index){
				this.qrcodeSetConfig.showConfig.settings_extra.lists=this.funcData
				this.qrcodeSetConfig.showConfig.settings_extra.currentindex=index
				this.qrcodeSetConfig.id_key="";
				this.qrcodeSetConfig.showDetailSet = true;
				this.title=index+1+'.'+this.funcData[index].name;
				this.addFunctionaltyHeat(item.id);
			},
			/*热度自增*/
			addFunctionaltyHeat(id){
				this.$apiRequest.post('/func/addFunctionaltyHeat',{
					id:id,
				}).then(res => {
				}).catch(err => {
				});
			},
			/*关闭二维码设置*/
			qrcodeSetCancel(){
				this.qrcodeSetConfig.showDetailSet = false;
				this.qrcodeSetConfig.id_key="";
			},
			/*确认并关闭二维码设置*/
			qrcodeSetOk(){
				this.qrcodeSetConfig.showDetailSet = false;
				this.qrcodeSetConfig.id_key="";
			},
			getFunctionaltyInfo(){
				this.$apiRequest.post('/func/getFunctionaltyInfo',{
					page:1,
					size:100,
				}).then(res => {
					this.funcData = res.data.data.data;
				}).catch(err => {
				});
			},
		}
	}
</script>

<style>
	.funcListTitle{
		font-size: 24px;
		color: #262e48;
		width: 100%;
		text-align: center;
		line-height: 1;
		margin-bottom: 88px;
	}
	.funcList:nth-child(-n+4) .funclistNum{
		color:#ff4429 !important;
	}
	.funcListR1{
		/* width: 180px; */
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 14px;
		margin-right: 60px;
		text-align: left;
		font-weight: 600;
	}
	.funcListR2{
		margin-right: 60px;
		width: 65px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
	}
	.funcListGo{
		width: 60px;
		height: 30px;
	}
	.funclistDesc{
		font-size: 12px;
		color: #555;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-left: 15px;
	}
	.funclistDesc1{
		display: flex;
		font-size: 16px;
		align-items: center;
	}
	.funcIsnew{
		width: 40px;
		border-radius: 10px;
		background-color: #09bd71;
		font-size: 12px;
		display: inline-block;
		text-align: center;
		line-height: 18px;
		color: white;
		/* transform: scale(.9); */
		margin-left: 8px;
	}
	.funclistDesc1 h2{
		/* max-width: 400px; */
		overflow: hidden;
		font-size: 16px;
		line-height: 25px;
		height: 25px;
		text-overflow: ellipsis;
		margin: 0;
		/* font-weight: 600; */
		white-space: nowrap;
	}
	.funclistDesc2{
		/* width: 300px; */
		margin-bottom: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.funclistInfoImg{
		width: 30px;
		height: 30px;
	}
	.funclistInfo{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 10px;
	}
	.funclistHot1{
		font-size: 12px;
		color: #777;
	}
	.funclistHot2{
		display: inline-block;
		width: 60px;
		text-align: center;
		font-size: 12px;
		color: #777;
	}
	.funclistHot{
		font-size: 0;
		width: 60px;
		text-align: center;
	}
	.funclistNum{
		font-size: 22px;display: inline-block;
		width: 40px;
		/* text-align: center; */
	}
	.funcListL,.funcListR{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.funcList{
		margin-bottom:30px;
		display: flex;
		justify-content: space-between;
		padding: 0 11px;
	}
	.funcListContainer{
		padding: 47px 0px 30px 0px;
		width: 1200px;
		max-width: 1200px;
		/* background-color: #fafafe; */
		margin: 0 auto;
	}
</style>